import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
  import CourseItem from '@/components/course/CourseItem.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import useSegment from '@/composables/useSegment'
  import CuratedContentApi from '@/services/api/CuratedContentApi'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'
  import type { CourseItem as RecommendedCourseItem } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'UpsellModal',
  props: {
    recommendedCourse: {
      type: Object as () => RecommendedCourseItem,
      required: true,
    },
    discount: {
      type: Number,
      default: 0,
    },
  },
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

  
  
  const { recommendedCourseClicked, recommendedCourseGetNotified } = useSegment()
  const { translateString } = useI18n()
  const submittingInterestedCourse = ref(false)

  const submitInterestedCourse = () => {
    submittingInterestedCourse.value = true
    CuratedContentApi.postInterestedCourse(props.recommendedCourse.id)
      .then(() => {
        recommendedCourseGetNotified(props.recommendedCourse.id, props.recommendedCourse.title)
        eventBus.$toasted.success(translateString('upsellSection.modal.notifySuccessMessage'))
      })
      .finally(() => {
        submittingInterestedCourse.value = false
        emit('close')
      })
  }

  onMounted(() => {
    recommendedCourseClicked(props.recommendedCourse.id, props.recommendedCourse.title)
  })

return { __sfc: true,props, emit, recommendedCourseClicked, recommendedCourseGetNotified, translateString, submittingInterestedCourse, submitInterestedCourse, onMounted, ref, CourseItem, KetchUpButton, useSegment, CuratedContentApi, eventBus, useI18n }
}

})